// extracted by mini-css-extract-plugin
export var modalFooter = "_oz-0";